import React from "react";
import PropTypes from "prop-types";

import BottomBar from "../../../ui/BottomBar";
import StepContainer from "../../../ui/StepContainer";
import StepForm from "../../../ui/StepForm";
import {
  COST_PARAMETERS_STORAGE_KEYS,
  STEP_STORAGE_KEYS,
} from "../../../constants/storageConstants";
import { projectDataPropType } from "../../../util/propTypeHelper";
import OperationsAndMaintenanceForm from "./OperationsAndMaintenanceForm";
import { getAnalysisType } from "../../../util/dataSelectors";
import Header from "../../../ui/Header";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routesConstants";
import TextInput from "../../../ui/TextInput";

export default function OperationsAndMaintenanceDefaults({
  projectData,
  saveFormData,
}) {
  const navigate = useNavigate();
  const handleButtonClick = () => navigate(ROUTES.COST_PARAMETERS);
  return (
    <StepContainer withProgressStepper={false}>
      <StepForm
        arrayPropertyPath={`${COST_PARAMETERS_STORAGE_KEYS.COST_PARAMETERS}.${COST_PARAMETERS_STORAGE_KEYS.OPERATIONS_AND_MAINTENANCE}`}
        isOnChangeMode={false}
        onFormSubmit={handleButtonClick}
        projectData={projectData}
        saveFormData={saveFormData}
        storageKey={STEP_STORAGE_KEYS.INTERSECTIONS}
      >
        {({ defaultValues, errors, formData, register }) => {
          return (
            <>
              <Header
                subtitle="Contains default operations and maintenance costs. Default values can be overridden"
                title="Cost Parameters Defaults"
              />
              <OperationsAndMaintenanceForm
                analysisType={getAnalysisType(projectData)}
                defaultValues={defaultValues}
                errors={errors}
                formData={formData}
                intersections={projectData[STEP_STORAGE_KEYS.INTERSECTIONS]}
                register={register}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <TextInput
                  errors={errors}
                  name={"example input"}
                  register={register}
                  size="small"
                  startAdornment="$"
                  sx={{
                    marginRight: "5px",
                    maxWidth: "130px",
                    "& .MuiOutlinedInput-root.Mui-disabled": {
                      "& > fieldset": { border: 2, borderColor: "orange" },
                    },
                  }}
                  type="number"
                  disabled={true}
                />{" "}
                Orange border denotes the default value is overridden.
              </div>

              <BottomBar
                handleSecondaryButtonClick={handleButtonClick}
                isFullScreenWidth
                mainButtons={[{ label: "Save" }]}
                projectData={projectData}
                secondaryButtonLabel="Cancel"
                withSubmitButton
              />
            </>
          );
        }}
      </StepForm>
    </StepContainer>
  );
}

OperationsAndMaintenanceDefaults.propTypes = {
  projectData: projectDataPropType.isRequired,
  saveFormData: PropTypes.func.isRequired,
};
